!function(c,d){function b(){var a=d.documentElement,b=a.clientWidth;a.style.fontSize=750>=b?b/750*100+"px":"100px"}resizeEvt="orientationchange"in window?"orientationchange":"resize";var a=null;c.addEventListener(resizeEvt,function(){clearTimeout(a);a=setTimeout(b,300)},!1);c.addEventListener("pageshow",function(c){c.persisted&&(clearTimeout(a),a=setTimeout(b,300))},!1);b()}(window,document);


// WEBPACK FOOTER //
// ./src/assets/js/rem.js